import PropTypes from 'prop-types'

import {DESIGNS} from '../../config.js'
import FormLocationContent from '../Content/index.js'

const FormLocationModalPopover = ({aggregations, autoFocus, isLoading, onChange, search}) => {
  const handleSelectLocation = (_, location) => {
    onChange(_, location)
  }

  return (
    <FormLocationContent
      autoFocus={autoFocus}
      aggregations={aggregations}
      design={DESIGNS.MODAL_POPOVER}
      isLoading={isLoading}
      onChange={handleSelectLocation}
      search={search}
      withLabel={false}
    />
  )
}

FormLocationModalPopover.displayName = 'FormLocationModalPopover'
FormLocationModalPopover.propTypes = {
  aggregations: PropTypes.array,
  autoFocus: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  search: PropTypes.object
}

export default FormLocationModalPopover
